import PropTypes from 'prop-types'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { useClickOutside } from '../../helpers/hooks/useClickOutside'

import PerksForm from './PerksForm'

const CreatePerks = ({ buildingId, close, perksData }) => {
  const modalRef = useRef(null)
  const { t } = useTranslation(['neighborhood-perks'])

  useClickOutside(modalRef, () => close())

  return (
    <div className={`ctp-create-perks-modal`}>
      <div ref={modalRef} className="ctp-create-perks">
        <div className="form__header ctp-create-perks__header">
          <h1>
            {perksData
              ? t('neighborhood-perks:form.title.edit')
              : t('neighborhood-perks:form.title.add')}
          </h1>
        </div>
        <PerksForm buildingId={buildingId} close={close} perksData={perksData} />
      </div>
    </div>
  )
}

CreatePerks.propTypes = {
  buildingId: PropTypes.string.isRequired,
  close: PropTypes.func,
  perksData: PropTypes.object,
}

export default CreatePerks
